//ant design
import Antd from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import VuePaginate from "vue-paginate";
import Searcher from "./Searcher";
import Vue from "vue";
Vue.use(Antd);
Vue.use(VuePaginate);
Vue.component("products", Searcher);

new Vue({
  el: "#app",
});
